import {
  SB,
  createComputedProperties,
  searchableComputedProperty,
} from '@play-co/replicant';

import { stateSchema } from '../State';

const platformStorageSchema = SB.object({
  demographics: SB.object({
    ageRange: SB.object({
      min: SB.int(),
    }).additionalProperties(),
  }).additionalProperties(),
}).additionalProperties();

export const demographicsProperties = createComputedProperties(stateSchema)({
  ageRangeMin: searchableComputedProperty(SB.int(), (state) => {
    const { platformStorage } = state;

    if (!platformStorageSchema.isValid(platformStorage)) {
      return -1; // TODO: fall back to `undefined` instead of -1 once Replicant supports `property exists` index queries (https://github.com/play-co/replicant/issues/2051)
    }

    return platformStorage.demographics.ageRange.min;
  }),
});
